import { Currency } from '@/core/currency/interfaces';

const MOP: Currency = {
    name: 'Macanese Pataca',
    demonym: 'Macanese',
    majorSingle: 'Pataca',
    majorPlural: 'Patacas',
    codeNumeric: '446',
    symbol: 'MOP$',
    symbolNative: 'MOP$',
    minorSingle: 'Avo',
    minorPlural: 'Avos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MOP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MOP;
